import script from "./ScoreSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreSlider.vue?vue&type=script&setup=true&lang=js"

import "./ScoreSlider.vue?vue&type=style&index=0&id=457c5dac&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457c5dac"]])

export default __exports__